export default function getPlacementKey(placementId: string, dspId: number) {
  return `${placementId}-${dspId}`;
}